import type { DealInsightsGeneralStatsApi } from '@openx/types/dealInsights';

export const mockGeneralData: DealInsightsGeneralStatsApi = {
  previous_period_calculated: true,
  impressions: { value: 332940000, percentage_change: 0.00324 },
  spend: { value: 2130000, percentage_change: -0.0324 },
  ecpm: { value: 6.4, percentage_change: -0.01 },
  bid_rate: { value: 0.3, percentage_change: 0.0 },
  win_rate: { value: 10.05, percentage_change: 0.0 },
  viewability: { value: 78.23, percentage_change: 0.0 },
  vcr: { value: 85.86, percentage_change: 0.0 },
  ctr: { value: 0.32, percentage_change: 0.0 },
  iqs_on_impression: { value: 78, percentage_change: 0.123 },
};
